import * as Actions from '../actions/actions'
import * as ActionTypes from '../actions/types'
import { API, PortalToken } from "../helpers/constants";
import { requestCreator } from '../helpers/redux/requestCreator'
import { getEndPoint } from "../helpers/constants";

const checkAPIConnectivity = requestCreator({
	nonApiUrl: true,
	url: API + '/portcheck.txt?t=' + (new Date()).getTime(),
	method: 'GET',
	onSuccess: Actions.checkAPIConnectivitySucceeded,
	onFailure: Actions.checkAPIConnectivityFailed
})

// User --------------------------------------------------------
const userLogout = requestCreator({
	url: '/logout',
	method: 'GET', // Change to POST if API uses POST
	onSuccess: Actions.userLogoutSucceeded,
	onFailure: Actions.userLogoutFailed,
	headers: {
		'Content-Type': 'multipart/form-data',
		'TokenGuid': PortalToken
	}
})

const userLogin = requestCreator({
	// url: '/login',
	url: getEndPoint('portalLogin'),
	method: 'POST',
	onSuccess: Actions.userLoginSucceeded,
	onFailure: Actions.userLoginFailed,
	// headers: {
	// 	'Content-Type': 'multipart/form-data',
	// }
})

const requestResetPassword = requestCreator({
	url: '/request/new-password',
	method: 'GET',
	onSuccess: Actions.requestResetPasswordSucceeded,
	onFailure: Actions.requestResetPasswordFailed,
	headers: {
		'Content-Type': 'multipart/form-data',
		'TokenGuid': PortalToken
	}
})

const resetPassword = requestCreator({
	url: '/store/new/password',
	method: 'POST',
	onSuccess: Actions.resetPasswordSucceeded,
	onFailure: Actions.resetPasswordFailed,
	headers: {
		'Content-Type': 'multipart/form-data',
		'TokenGuid': PortalToken
	}
})

const getUserDetails = requestCreator({
	url: '/portal/user/details',
	method: 'GET',
	onSuccess: Actions.getUserDetailsSucceeded,
	onFailure: Actions.getUserDetailsFailed,
})

// Grid State -------------------------------------------------
const getGridState = requestCreator({
	url: '/uigrid/state/load',
	method: 'POST',
	onSuccess: Actions.getGridStateSucceeded,
	onFailure: Actions.getGridStateFailed,
})

const saveGridState = requestCreator({
	url: '/uigrid/state/save',
	method: 'POST',
	onSuccess: Actions.saveGridStateSucceeded,
	onFailure: Actions.saveGridStateFailed,
})

const deleteGridState = requestCreator({
	url: '/uigrid/state/save',
	method: 'POST',
	onSuccess: Actions.deleteGridStateSucceeded,
	onFailure: Actions.deleteGridStateFailed,
})

const setActiveGridState = requestCreator({
	url: '/uigrid/state/save',
	method: 'POST',
	onSuccess: Actions.setActiveGridStateSucceeded,
	onFailure: Actions.setActiveGridStateFailed,
})

// Grant Application API handlers ----------------------

const fetchCountries = requestCreator({
	url: getEndPoint("countries"),
	method: "POST",
	onSuccess: Actions.fetchCountriesSucceeded,
	onFailure: Actions.fetchCountriesFailed
});

const fetchCounties = requestCreator({
	url: getEndPoint("counties"),
	method: "POST",
	onSuccess: Actions.fetchCountiesSucceeded,
	onFailure: Actions.fetchCountiesFailed
});

const fetchCurrencies = requestCreator({
	url: getEndPoint("currencies"),
	method: "POST",
	onSuccess: Actions.fetchCurrenciesSucceeded,
	onFailure: Actions.fetchCurrenciesFailed
});

const findOrganization = requestCreator({
	url: getEndPoint("findOrganization"),
	method: "POST",
	onSuccess: Actions.findOrganizationSucceeded,
	onFailure: Actions.findOrganizationFailed
});

const createRequest = requestCreator({
	url: getEndPoint("createRequest"),
	method: "POST",
	onSuccess: Actions.createRequestSucceeded,
	onFailure: Actions.createRequestFailed
});

const requestDocuments = requestCreator({
	url: getEndPoint("requestDocuments"),
	method: "POST",
	onSuccess: Actions.requestDocumentsSucceeded,
	onFailure: Actions.requestDocumentsFailed
});

const requestDocumentsList = requestCreator({
	url: getEndPoint("requestDocumentsList"),
	method: "POST",
	onSuccess: Actions.requestDocumentsListSucceeded,
	onFailure: Actions.requestDocumentsListFailed
});

const requestNumber = requestCreator({
	url: getEndPoint("requestNumber"),
	method: "POST",
	onSuccess: Actions.requestNumberSucceeded,
	onFailure: Actions.requestNumberFailed
});


const requestHandler = {
	[ActionTypes.CHECK_API_CONNECTIVITY]: checkAPIConnectivity,
	// User -----------------------------------------------
	// [ActionTypes.USER_LOGOUT]: userLogout,
	[ActionTypes.USER_LOGIN]: userLogin,
	[ActionTypes.REQUEST_RESET_PASSWORD]: requestResetPassword,
	[ActionTypes.RESET_PASSWORD]: resetPassword,
	[ActionTypes.GET_USER_DETAILS]: getUserDetails,
	// Grid State -------------------------------------------------
	[ActionTypes.GET_GRID_STATE]: getGridState,
	[ActionTypes.SAVE_GRID_STATE]: saveGridState,
	[ActionTypes.DELETE_GRID_STATE]: deleteGridState,
	[ActionTypes.SET_ACTIVE_GRID_STATE]: setActiveGridState,

	[ActionTypes.FETCH_COUNTRIES]: fetchCountries,
	[ActionTypes.FETCH_COUNTIES]: fetchCounties,
	[ActionTypes.FETCH_CURRENCIES]: fetchCurrencies,

	[ActionTypes.FIND_ORGANIZATION]: findOrganization,
	[ActionTypes.CREATE_REQUEST]: createRequest,

	[ActionTypes.REQUEST_DOCUMENTS]: requestDocuments,
	[ActionTypes.REQUEST_DOCUMENTS_LIST]: requestDocumentsList,

	[ActionTypes.REQUEST_NUMBER]: requestNumber,

}

export default requestHandler
